import React, { Fragment, JSX } from 'react';

const AdditionalContent = ({
  hasFilters,
  additionalContent
}: {
  hasFilters: boolean;
  additionalContent?: Array<{ id: number; component: JSX.Element }>;
}): JSX.Element => {
  return (
    <>
      {additionalContent && (
        <div>
          {additionalContent.map(c => (
            <Fragment key={c.id}>
              {' '}
              {hasFilters && <br />} {c.component}{' '}
            </Fragment>
          ))}
          <br />
        </div>
      )}
    </>
  );
};

export default AdditionalContent;
